import {AxiosInstance} from "axios";
import API from "../../utils/api";

export class ForgotPasswordService {
    private api: AxiosInstance = API;

    public sendEmail(values: {email: string}) {
        return this.api.post("auth/pw_reset/request", values)
    }

    public checkIfCompleted(values: {code: string, email: string}) {
        return this.api.post("auth/pw_reset/confirm", values);
    }
}

export const forgotPasswordService = new ForgotPasswordService();